function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m219.495 114c0-51.36-41.64-93-93-93s-93 41.64-93 93c0 47.018 35.012 86.233 80.874 92.213 55.284 7.202 105.126-35.638 105.126-92.213z",
  fill: "#ffe773"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m134.369 66.575c-25.065 9.609-45.453 29.992-55.129 55.031-9.475 24.518-45.898 18.12-45.743-8.165.3-50.814 41.76-92.088 92.339-92.439 26.375-.183 33.16 36.131 8.533 45.573z",
  fill: "#fff0a6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m429.693 114c6.735 0 10.456 7.815 6.21 13.043-46.613 57.399-142.725 175.728-142.422 175.355-3.602 4.435-10.37 4.434-13.972 0-2.639-3.249-142.629-175.612-142.421-175.355-4.246-5.228-.526-13.043 6.21-13.043z",
  fill: "#ff6d7a"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m435.905 127.04c-39.534 48.683-11.118 13.693-142.42 175.36-3.61 4.43-10.37 4.43-13.98 0l-42.121-51.862c-5.396-6.644-2.294-16.615 5.908-19.063 48.414-14.452 81.595-57.155 86.193-106.583.574-6.171 5.742-10.892 11.939-10.892h88.271c6.73 0 10.45 7.81 6.21 13.04z",
  fill: "#fe4f60"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m435.903 127.043-30.508 37.567c-34.48 18.53-61.8 21.32-80.25 20.47-35.389-1.265-56.6-18.58-97.65-15.08-20.18 1.72-36.13 7.62-45.83 11.93l-44.577-54.887c-4.246-5.228-.526-13.043 6.21-13.043h286.394c6.736 0 10.457 7.815 6.211 13.043z",
  fill: "#e3f7fc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m435.905 127.04-30.51 37.57c-30.773 16.538-62.854 24.54-96.68 18.66 11.596-17.206 18.81-37.306 20.77-58.378.574-6.171 5.742-10.892 11.939-10.892h88.271c6.73 0 10.45 7.81 6.21 13.04z",
  fill: "#caf1fc"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m388.495 8c20.43 0 37 16.57 37 37 0 26.988-27.972 44.736-52.25 33.72v-.01c-12.83-5.81-21.75-18.72-21.75-33.71 0-20.43 16.57-37 37-37z",
  fill: "#befa91"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m407.569 32.981c-16.285.879-30.554 12.801-34.224 28.712-1.796 7.788-12.212 9.453-16.398 2.646-4.503-7.321-6.353-16.095-5.036-24.919 4.246-28.443 38.859-41.66 60.983-22.232 6.06 5.321 2.728 15.358-5.325 15.793z",
  fill: "#daffbf"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m446.495 106h-38c-4.418 0-8 3.582-8 8s3.582 8 8 8h21.196l-29.465 36.279c-21.41 11.303-42.419 17.587-62.652 18.735l39.96-88.362c28.505 7.148 55.961-14.543 55.961-43.652 0-24.813-20.187-45-45-45s-45 20.187-45 45c0 4.418 3.582 8 8 8s8-3.582 8-8c0-15.991 13.009-29 29-29s29 13.009 29 29c0 19.03-18.765 34.966-40.545 26.63-4.16-2.17-9.128-.332-10.989 3.785l-13.831 30.585h-124.951c-4.092-51.966-47.685-93-100.684-93-55.691 0-101 45.308-101 101s45.309 101 101 101c4.418 0 8-3.582 8-8s-3.582-8-8-8c-46.869 0-85-38.131-85-85s38.131-85 85-85c44.17 0 80.565 33.87 84.612 77h-84.612c-6.722 0-10.449 7.824-6.21 13.043l158.21 194.796v150.161h-63c-4.418 0-8 3.582-8 8s3.582 8 8 8h142c4.418 0 8-3.582 8-8s-3.582-8-8-8h-63v-150.161c6.966-8.577 150.756-185.618 158.21-194.796 4.239-5.219.512-13.043-6.21-13.043zm-101.601 16-24.746 54.72c-32.098-2.923-52.979-18.138-93.333-14.691-4.402.376-7.666 4.249-7.291 8.651.376 4.402 4.254 7.667 8.652 7.291 34.938-2.984 53.825 9.957 85.042 14.072l-3.012 6.661c-1.821 4.026-.033 8.765 3.993 10.586 4.024 1.82 8.765.034 10.585-3.993l5.467-12.089c16.55.069 32.656-2.922 48.22-8.143l-91.977 113.246-143.195-176.311zm-226.399-52v-10c0-4.418 3.582-8 8-8s8 3.582 8 8v10c0 4.418-3.582 8-8 8s-8-3.582-8-8zm-36 36c4.418 0 8 3.582 8 8s-3.582 8-8 8h-10c-4.418 0-8-3.582-8-8s3.582-8 8-8z"
});

var SvgCocktail = function SvgCocktail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 480 480",
    height: 512,
    viewBox: "0 0 480 480",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCocktail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cocktail.32ef6572.svg";
export { ForwardRef as ReactComponent };